import { message } from "antd";
import ComplaintApi from "app/api/complaint";
import { handleGenericApiError } from "app/api/error";
import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_COMPLAINTS = "complaint:ACTION_SAVE_COMPLAINTS";
export const ACTION_SAVE_COMPLAINT = "complaint:ACTION_SAVE_COMPLAINT";

export const fetchComplaintsByUserId = userId => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await ComplaintApi.fetchComplaintsByUserId(userId);
    dispatch({ type: ACTION_SAVE_COMPLAINTS, payload: data });
    return data;
  } catch (err) {
    handleGenericApiError(err);
    return null;
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchComplaintById = id => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await ComplaintApi.fetchComplaintById(id);
    dispatch({ type: ACTION_SAVE_COMPLAINT, payload: data });
    return data;
  } catch (err) {
    handleGenericApiError(err);
    return null;
  } finally {
    dispatch(removeLoading());
  }
};

export const createComplaint = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await ComplaintApi.createComplaint(data);
    if (callback && typeof callback === "function") {
      callback();
    }
    message.success("Reclamação cadastrada com sucesso!");
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateComplaint = (id, data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await ComplaintApi.updateComplaint(id, data);
    if (callback && typeof callback === "function") {
      callback();
    }
    message.success("Reclamação atualizada com sucesso!");
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteComplaint = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await ComplaintApi.deleteComplaint(id);
    if (callback && typeof callback === "function") {
      callback();
    }
    message.success("Reclamação excluída com sucesso!");
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

